import { useEffect, useState } from 'react'

import Api from 'services/api'

import SearchHistory from 'types/SearchHistory'

const useSearchHistory = (userId, type, refreshTimestamp) => {
  const [searchHistory, setSearchHistory] = useState<Array<SearchHistory>>([])
  const [isSearchHistoryLoaded, setIsSearchHistoryLoaded] = useState(false)

  useEffect(() => {
    setIsSearchHistoryLoaded(false)

    Api.SearchHistory.list(userId, type)
      .then((res) => {
        setSearchHistory(res)
        setIsSearchHistoryLoaded(true)
      })
      .catch(() => {
        setSearchHistory([])
        setIsSearchHistoryLoaded(true)
      })
  }, [refreshTimestamp]) // eslint-disable-line react-hooks/exhaustive-deps

  return { searchHistory, isSearchHistoryLoaded }
}

export default useSearchHistory
